import { DeployerGridBaseDataProvider } from '../dataProvider/DeployerGridBaseDataProvider';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';
import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';

export class DeployerGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, DeployerGridBaseDataProvider);
  }
}
